import cardsModal from './cards-modal';
export default cardsModal;
